"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormItem = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var FormControl_1 = require("./FormControl");
var FormContext_1 = require("./FormContext");
var config_context_1 = require("../_util/config-context");
var bubble_1 = require("../bubble");
var icon_1 = require("../icon");
exports.FormItem = react_1.default.forwardRef(function FormItem(_a, ref) {
    var htmlFor = _a.htmlFor, label = _a.label, children = _a.children, status = _a.status, message = _a.message, extra = _a.extra, align = _a.align, required = _a.required, tips = _a.tips, _b = _a.showStatusIcon, showStatusIcon = _b === void 0 ? true : _b, suffix = _a.suffix, className = _a.className, props = tslib_1.__rest(_a, ["htmlFor", "label", "children", "status", "message", "extra", "align", "required", "tips", "showStatusIcon", "suffix", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement(FormContext_1.FormContext.Consumer, null, function (_a) {
        var hideLabel = _a.hideLabel, fixedLabelWidth = _a.fixedLabelWidth;
        return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-form__item", className) }, props),
            !hideLabel && (react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-form__label", {
                    "is-required": required,
                }) }, typeof label !== "undefined" && (react_1.default.createElement("label", { htmlFor: htmlFor, style: fixedLabelWidth ? { width: fixedLabelWidth } : undefined },
                label,
                tips && (react_1.default.createElement(react_1.default.Fragment, null,
                    " ",
                    react_1.default.createElement(bubble_1.Bubble, { content: tips },
                        react_1.default.createElement(icon_1.Icon, { type: "info" })))))))),
            react_1.default.createElement(FormControl_1.FormControl, { status: status, showStatusIcon: showStatusIcon, message: message, extra: extra, alignLabelTop: isAlignLabelTop(align, children) },
                children,
                suffix && (react_1.default.createElement("div", { className: classPrefix + "-form__help-text--inline" }, suffix)))));
    }));
});
exports.FormItem.displayName = "FormItem";
function isAlignLabelTop(align, children) {
    if (align === "top") {
        return true;
    }
    if (align === "middle") {
        return false;
    }
    return getDefaultAlign(children) === "top";
}
function getDefaultAlign(control) {
    if (react_1.default.isValidElement(control) &&
        // 普通组件是 function, forwaredRef 是 object
        (typeof control.type === "function" || typeof control.type === "object") &&
        "defaultLabelAlign" in control.type) {
        return control.type["defaultLabelAlign"]; // eslint-disable-line dot-notation
    }
    return "top";
}
//# sourceMappingURL=FormItem.js.map